const PhoneIcon = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.95 21c-2.083 0-4.142-.454-6.175-1.362-2.033-.908-3.883-2.196-5.55-3.863-1.667-1.667-2.954-3.517-3.862-5.55C3.454 8.192 3 6.133 3 4.05c0-.3.1-.55.3-.75.2-.2.45-.3.75-.3h4.025c.233 0 .442.079.625.237.183.158.292.346.325.563l.65 3.5c.033.267.025.492-.025.675a1.137 1.137 0 0 1-.3.5L6.975 10.9c.633 1.1 1.429 2.13 2.387 3.088A16.6 16.6 0 0 0 12.6 16.4l2.325-2.325c.15-.15.346-.262.588-.337.241-.075.479-.096.712-.063l3.45.7c.234.05.425.166.575.35.15.183.225.391.225.625V20c0 .3-.1.55-.3.75-.2.2-.45.3-.75.3Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PhoneIcon;
